import { lazy } from "react";

export const DocumentsView = lazy(() => import("./DocumentsView"));
export const RootFolderRedirect = lazy(() => import("./RootFolderRedirect"));
export const ManageAccessView = lazy(() => import("./ManageAccessView"));
